import styled from "styled-components";

// 모달창을 띄워주는 버튼 List
const ModalButtonList = styled.ul`
    width: 100vw;
    display: flex;
    border-bottom: 1px solid black;
`

export default ModalButtonList